import { HttpContextToken } from '@angular/common/http';

// Opt in only for callers that inspect status/code to recover from failed commands.
export const PRESERVE_HTTP_ERROR = new HttpContextToken<boolean>(() => false);
